import vueFragment from 'vue-fragment'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import responsiveBreakpoints from './plugins/responsive-breakpoints'
import events from './plugins/events'
import cssVariables from './plugins/css-variables'
require('flexboxgrid')

Vue.config.productionTip = false

Vue.use(vueFragment.Plugin)
Vue.use(events)
Vue.use(responsiveBreakpoints, { debug: process.env.NODE_ENV === 'development' })
Vue.use(cssVariables, {
  scrim: 'rgba(0, 0, 0, 0.32)'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
